<template>
  <!-- Table -->
  <div class="row">
    <div class="col-sm-12">
      <div class="card-table">
        <div class="card-body">
          <div class="table-responsive">
            <a-table
              class="stripped table-hover"
              :columns="columns"
              :data-source="customer_expenses"
            >
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'index'">
                  {{ index + 1 }}
                </template>
                <template v-if="column.key === 'amount'">
                  {{ record?.currency?.slice(0, 3) }}
                  {{ addCurrencyComma(record.amount) }}
                </template>
                <template v-if="column.key === 'created_at'">
                  {{ formatted(record.created_at) }}
                </template>
                <template v-if="column.key === 'date'">
                  {{ formatted(record.date) }}
                </template>

                <template v-else-if="column.key === 'status'">
                  <span
                    class="badge bg-success-light text-success-light text-capitalize"
                    v-if="
                      record.status === 'paid' ||
                      record.status === 'refunded' ||
                      record.status === 'sent' ||
                      record.status === 'viewed' ||
                      record.status === 'accepted'
                    "
                    >{{ record.status }}</span
                  >
                  <span
                    class="badge bg-warning-light text-warning-light text-capitalize"
                    v-else-if="
                      record.status === 'draft' ||
                      record.status === 'pending' ||
                      record.status === 'unpaid' ||
                      record.status === 'recurring'
                    "
                    >{{ record.status }}</span
                  >
                  <span
                    class="badge bg-warning-light text-warning-light text-capitalize"
                    v-else-if="record.status === 'partially_paid'"
                    >Partially paid</span
                  >
                  <span
                    class="badge bg-danger-light text-capitalize"
                    v-else-if="
                      record.status === 'expired' ||
                      record.status === 'rejected' ||
                      record.status === 'overdue'
                    "
                    >{{ record.status }}</span
                  >
                </template>
                <template v-else-if="column.key === 'action'">
                  <div class="d-flex align-items-center justify-content-start">
                    <div class="dropdown dropdown-action">
                      <a
                        class="btn-action-icon"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        >Action</a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <ul>
                          <li>
                            <a
                              @click="openViewModal(record)"
                              class="dropdown-item"
                              ><i class="far fa-eye me-2"></i>View</a
                            >
                          </li>
                          <li>
                            <a
                              @click="openEditModal(record)"
                              class="dropdown-item"
                              ><i class="far fa-edit me-2"></i>Edit</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'duplicate')"
                              ><i class="far fa-clone me-2"></i>Duplicate</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'refund')"
                              ><i class="fa fa-undo me-2"></i>Mark as
                              refunded</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'delete')"
                              ><i class="far fa-trash-alt text-danger me-2"></i
                              >Delete</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Table -->
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { formatted } from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";

const store = useStore();
const route = useRoute();
const emit = defineEmits(["openModal", "openViewModal", "openEditModal"]);
const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Amount",
    key: "amount",
    sorter: true,
  },
  {
    title: "Date Created",
    key: "created_at",
    sorter: true,
  },
  {
    title: "Expiry Date",
    key: "date",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const openModal = (record, name) => {
  let data = {
    data: record,
    name: name,
  };
  emit("openModal", data);
};
const openViewModal = (record) => {
  emit("openViewModal", record);
};
const openEditModal = (record) => {
  emit("openEditModal", record);
};

const getCustomerHistory = () => {
  store.dispatch("customer/getCustomerHistory", route.params.id);
};

const customer_expenses = computed(() => {
  return store.getters["customer/customer_history"].expenses;
});

onMounted(() => {
  getCustomerHistory();
});
</script>
